import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {BaseDrawer} from "@/drawings3D/modelDrawing/BaseDrawer"

export class TunnelDrawer extends BaseDrawer {
  constructor(tunnel, sceneManager){
    super(sceneManager, tunnel.startStake,tunnel.endStake, tunnel.allRoadStakes);
    this.tunnelMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/concreteSurface.jpg")
  });
    this.tunnel = tunnel;
    
    
  }

  draw(){
        var curveLine = this.tunnel.botCenterLine;
        
        
        var spline = new THREE.CatmullRomCurve3(curveLine);

        spline.curveType = 'catmullrom';
        spline.closed = false;

        var extrudeSettings = {
          steps: this.roadStakesLen * 5,
          bevelEnabled: false,
          extrudePath: spline
        };

        var width = this.tunnel.botCenterLine[0].width;
        //在起点构建shape
        var tunnelInnerHeight = this.tunnel.tunnelInnerHeight;
        var tunnelOuterHeight = this.tunnel.tunnelOuterHeight;
        var tunnelOuterWidth = this.tunnel.tunnelOuterWidth;
        var tunnelShape = new THREE.Shape();
        tunnelShape.moveTo(0, -width/2);
        tunnelShape.lineTo(0, -width/2 - tunnelOuterWidth);
        tunnelShape.lineTo(-tunnelOuterHeight, -width/2 - tunnelOuterWidth);
        tunnelShape.bezierCurveTo(-1.3 * tunnelOuterHeight, -width/2 - tunnelOuterWidth, 
          -1.3*tunnelOuterHeight, width/2 + tunnelOuterWidth, -tunnelOuterHeight, width/2 + tunnelOuterWidth);
        tunnelShape.lineTo(0, width/2 + tunnelOuterWidth);
        tunnelShape.lineTo(0, width/2);
        tunnelShape.lineTo(-tunnelOuterHeight + tunnelOuterWidth, width/2);
        tunnelShape.bezierCurveTo(-tunnelOuterHeight, width/2, 
          -tunnelOuterHeight, -width/2,  -tunnelOuterHeight + tunnelOuterWidth, -width/2);
        tunnelShape.lineTo(0, -width/2);
        var guradRailGeometry = new THREE.ExtrudeGeometry( tunnelShape, extrudeSettings);
        
        var guradRailMesh = new THREE.Mesh( guradRailGeometry, this.medialDividerMaterial);
        guradRailMesh.updateMatrix();
        this.geometry.merge(guradRailMesh.geometry, guradRailMesh.matrix);
        

        this.sceneManager.scene.add(new THREE.Mesh(this.geometry, this.tunnelMaterial));
  }
 
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/TunnelDrawer.js